import React, { Component, useCallback, useEffect } from 'react'
import { Label, Progress, Image, Container, FieldSet, Button, Spacer } from '@sencha/ext-modern'
// import immer, { setAutoFreeze } from 'immer'

import { getFileIcon, genFileSizeDesc, getUuid } from '../index'
import { doUpload, getDownloadUrl } from './Form/Block/renderFiles/fileServeDispatch'
import { FILESERVE_STATUS } from './Form/Block/renderFiles'
import { useInstData } from 'tyan/public/hooks'

// setAutoFreeze(false)

export const showImport = (event, title = '导入文件', onEventEnd = null, accept = '.xls,.xlsx', eventData = {}) => {
	if (!event) {
		Tyan.pubForm.showError('调用导入文件时无event函数')
		return
	}

	Tyan.pubForm.getFileInput(
		files => {
			if (files.length <= 0 || files[0].size <= 0) {
				Tyan.pubForm.showError('所选择上传文件为空文件')
				return
			}
			Tyan.pubForm.showDialog(title, FileImpExp, { IEMode: 'imp', event, title, onEventEnd, eventData, blob: files[0] })
		},
		accept
	)
}

export const showExport = ({ event, title = '导出文件', eventData = {}, onSuccess = null, open = false } = {}) => {
	const error = !event && '调用导出文件时无event参数传入'
	if (error)
		if (!event) {
			Tyan.pubForm.showError(error)
			return
		}

	Tyan.pubForm.showDialog(title, FileImpExp, { IEMode: 'exp', event, title, onSuccess, eventData, open })
}


const FileImpExp = props => {
	const { me, setState,
		me: { state, state: {
			error, uploaded, file: { message = '', Text = '', status = '', progress = 0 } = {}
		} }
	} = useInstData(props)

	const {
		_dialogShowed,
		IEMode, event, title, eventData, onClose,		// public
		onEventEnd, blob,					// IEMode == 'imp'
		onSuccess,									// IEMode == 'exp'
		open	//是否打开导出文件
	} = props

	const doImp = useCallback(() => {
		const file = {
			FileName: blob.name.lastIndexOf('.') < 0 ? blob.name : blob.name.slice(0, blob.name.lastIndexOf('.')),
			FileExt: blob.name.lastIndexOf('.') < 0 ? '' : blob.name.slice(blob.name.lastIndexOf('.')).toLowerCase(),
			FileSize: blob.size,
			type: blob.type,
			progress: 0,
			status: FILESERVE_STATUS.UPLOADING,
			blob,
		}

		// file.Text = genValueText(file)

		uploadFile(file)
		setState({ file })
	}, [])

	const doExp = useCallback(() => {
		Tyan.doPostEvent({
			event, data: eventData,
			onEnd: ({ errorMessage, FID, FileName, FileExt, longTranID }) => {
				if (me.unmounted) return
				if (errorMessage) {
					setState({ error: errorMessage })
					return
				}
				if (!longTranID) {
					// FID = FID.startsWith('_tmp_') ? FID : `_tmp_${FID}`
					if (open) window.open(getDownloadUrl({ FID, FileName, FileExt }))
					else {
						const a = document.createElement('a')
						a.download = FileName ? FileName + FileExt : FID//.slice(5)
						a.href = getDownloadUrl({ FID, FileName, FileExt }) // + '&token=' + getLoginToken()
						/* !Ext.platformTags.desktop && ( */a.target = '_blank'/* ) */
						a.click()
					}
					// window.open(getDownloadUrl({ FID }))
					onClose && onClose()
					onSuccess && onSuccess
				}
			}
		})
	}, [])

	const genValueText = value => `${value.FileName}.${value.FileExt} (${genFileSizeDesc(value.FileSize)})`

	const uploadFile = useCallback(file => {
		const onSuccess = ({ FID }) => {
			delete file.xhr
			delete state.file
			setState({ uploaded: true })
			Tyan.doPostEvent({
				event, data: { ...eventData, FID },
				onEnd: ({ errorMessage, longTranID, ...val }) => {
					if (errorMessage) {
						setState({ error: errorMessage })
						return
					}
					onClose && onClose()
					// if(longTranID)
					// 	Tyan.pubForm.showDialog(title, LongTranDlg, { id: longTranID, onLongTranEnd: onEventEnd }, { closable: true })
					if (!longTranID) {
						Ext.toast(`${title} 成功`)
						onEventEnd && onEventEnd(val)
					}
				}
			})
		}

		const onError = (msg) => {
			msg || (msg = `${title} 失败`)
			delete file.xhr
			file.status = FILESERVE_STATUS.ERROR
			setState({ error: msg, uploaded: false })
		}

		const onProgress = (percent) => {
			file.progress = percent
			setState({
				file,
				// uploaded: percent >= 99.99
			})
		}
		const { blob, FileSize, FileExt } = file
		file.xhr = doUpload({ blob, onSuccess, onError, onProgress, /* event,  */eventData: { temp: true, FileSize, FileExt } })
	}, [])

	const renderExport = () => <Container layout={{ type: 'hbox', align: 'center', pack: 'start' }} width='500'/* maxWidth='100%' */ margin='0 0 20 28'>
		<Button iconCls="x-fa fa-spinner fa-spin" />
		<Container layout='vbox' width/* maxWidth */="calc(100% - 97px)">
			<Container layout={{ type: 'hbox' }} >
				<Label html='数据处理中，请稍等...' />
			</Container>
		</Container>
	</Container >

	const renderImport = () => <>
		{uploaded && <Container layout={{ type: 'hbox', align: 'center', pack: 'start' }} width='500'/* maxWidth='100%' */ margin='0 0 20 28'>
			<Button iconCls="x-fa fa-spinner fa-spin" />
			<Container layout='vbox' width/* maxWidth */="calc(100% - 97px)">
				<Container layout={{ type: 'hbox' }} >
					<Label html='文件上传成功，数据处理中，请稍等...' />
				</Container>
			</Container>
		</Container >
			|| <Container layout={{ type: 'hbox', align: 'center', pack: 'start' }} width='500'/* maxWidth='100%' */ margin='0 0 20 28'>
				<Button iconCls="x-fa fa-upload" />
				<Container layout='vbox' width/* maxWidth */="calc(100% - 97px)">
					<Container layout={{ type: 'hbox' }} >
						<Label noLocale html={`${message ? message + ': ' : ''} ${Text}`} />
					</Container>
					<Container style={{ type: 'vbox' }} padding='0' margin='0' height={3} >
						{status != FILESERVE_STATUS.ERROR ? (<Progress value={progress / 100.0} height={3} minWidth={150} maxWidth='100%' />) : null}
					</Container>
				</Container>
				<Container layout='hbox' flex={1}>
					<Container layout={{ type: 'hbox', pack: 'end' }} minWidth='30'>
						<Label noLocale html={`${message ? '' : (Math.ceil(progress) + '%')}`} padding="0" />
					</Container>
				</Container>
			</Container >
		}
	</>

	useEffect(() => {
		if (!_dialogShowed)
			return

		IEMode == 'imp' ? doImp() : IEMode == 'exp' ? doExp() : onClose && onClose()
		return () => {
			const { file } = me.state
			file && file.xhr && file.xhr.abort()
		}
	}, [_dialogShowed])

	return (
		<>
			{error && <Container layout={{ type: 'hbox', pack: 'start' }} width='500'/* maxWidth='100%' */ margin='0 0 20 28'>
				<Container layout='hbox' flex={1}>
					<Container layout={{ type: 'hbox' }} flex={1}>
						<Label html={`${title}失败<br><br> ${error}`} margin="8 20 0 0" flex={1} />
					</Container>
				</Container>
			</Container >
				|| (IEMode == 'imp' ? renderImport() : IEMode == 'exp' ? renderExport() : null)}
			<Container docked="bottom" layout='hbox'>
				{/* <Button ui="action raised" width="150px" margin="0 0 20 28" iconCls="x-fa fa-upload" text="导入" handler={() => inputRef.current.click()} /> */}
				<Spacer height="10" />
				<Button ui="action raised" width="100px" margin="0 0 20 " iconCls="x-fa fa-close" disabled={!error && uploaded} text={(error && '关闭' || '取消')} handler={onClose} />
				<Spacer height="10" />
			</Container>
		</>
	)
}
